module.exports = __webpack_public_path__ + "static/media/note4.6b5e2a02.png";